import React from 'react'
import { Navbar, Nav, Container } from 'react-bootstrap'
import '../../css/sidenav.css'
import { Link } from 'react-router-dom'

const SideNav = () => {
    return (
        <>
            <div className='sidenav-body'>
                <Navbar className='sidebar-navigation'>
                    <Container className='sidebar-container'>
                        <Nav className="justify-content-center sidenav">
                            <h4 className='h4sidelink'>सम्वन्धित पेजहरु : :</h4>
                            <Nav.Link as={Link} to='/service/saving-service/compulsory-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>अनिवार्य बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/aichik-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>ऐच्छिक बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/daily-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>दैनिक बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/child-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>बाल बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/naari-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>पेवा (नारी) बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/jesta-nagarik-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>जेष्ठ नागरीक बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/health-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>स्वास्थ्य बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/aabadhik-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>आवधिक बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/akshaya-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>अक्षयकोष बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/future-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>भविष्य बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/festival-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>चाडपर्व बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/kramik-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>क्रमिक बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/loanpayment-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>ऋण भुक्तानी बचत</span>
                            </Nav.Link>
                            <Nav.Link as={Link} to='/service/saving-service/pratifal-saving' className='sidelink' onClick={() => window.scrollTo({ top: '0' })}>
                                <span>प्रतिफल बचत</span>
                            </Nav.Link>
                        </Nav>
                    </Container>
                </Navbar>
            </div>
        </>
    )
}

export default SideNav